<template>
    <div class="center admin">
        <h1 class="listTitle txtCenter">ADMIN TOOLS</h1>
        <router-link class="routeAdmin center uppercase" to="/brand-list" exact>{{ $t("headerAdmin.brand") }}</router-link>
        <router-link class="routeAdmin center" to="/admin/zones" exact>{{ $t("headerAdmin.zoneList") }}</router-link>
        <!-- Hide component type creation section because the dynamic of the new type does not work -->
        <!-- <router-link class="routeAdmin center" to="/componentType-list" exact>{{ $t("headerAdmin.componentList") }}</router-link> -->
        <router-link class="routeAdmin center" v-if="hasAccessSuperAdmin()" to="/admin/versionings" exact>VERSIONINGS</router-link>
        <router-link class="routeAdmin" v-if="hasAccessSuperAdmin()" to="/admin-tools/categories" exact>CATEGORIES</router-link>
        <router-link class="routeAdmin" v-if="hasAccessSuperAdmin()" to="/admin-tools/components" exact>COMPONENTS</router-link>
        <router-link class="routeAdmin" v-if="hasAccessSuperAdmin()" to="/admin/countdowns-list" exact>COUNTDOWN</router-link>
        <router-link class="routeAdmin" v-if="hasAccessSuperAdmin()" to="/admin/sso-system-list" exact>SSO SYSTEM</router-link>
        <router-link class="routeAdmin" v-if="hasAccessSuperAdmin()" to="/admin/properties" exact>PROPERTIES</router-link>
        <router-link class="routeAdmin" v-if="hasAccessSuperAdmin()" to="/admin/profiles" exact>PROFILES</router-link>
        <router-link class="routeAdmin" v-if="hasAccessSuperAdmin()" to="/admin/link-logs" exact>LINK LOGS</router-link>
    </div>
</template>

<script>
export default {
    data() {
        return {};
    },
    computed: {},
    created() {},
    mounted() {},
    methods: {}
};
</script>

<style scoped lang="scss">
@import "../../assets/css/themes.scss";

.admin {
    margin-bottom: 50px;
    text-align: center;
    @extend %primary-text;
    .listTitle {
        margin-bottom: 20px;
    }
}
.routeAdmin {
    @extend %primary-text;
    padding: 5px 20px;
    font-size: 15px;
    &.active,
    &.router-link-active,
    &:hover {
        border-bottom: 2px solid;
        @extend %second-border-color;
    }
}
body,
html {
    height: 100%;
}

/* remove outer padding */
.main .row {
    padding: 0px;
    margin: 0px;
}

/*Remove rounded coners*/

nav.sidebar.navbar {
    border-radius: 0px;
}

nav.sidebar,
.main {
    -webkit-transition: margin 200ms ease-out;
    -moz-transition: margin 200ms ease-out;
    -o-transition: margin 200ms ease-out;
    transition: margin 200ms ease-out;
}

/* Add gap to nav and right windows.*/
.main {
    padding: 10px 10px 0 10px;
}

/* .....NavBar: Icon only with coloring/layout.....*/

/*small/medium side display*/
@media (min-width: 768px) {
    /*Allow main to be next to Nav*/
    .main {
        position: absolute;
        width: calc(100% - 40px); /*keeps 100% minus nav size*/
        margin-left: 40px;
        float: right;
    }

    /*lets nav bar to be showed on mouseover*/
    nav.sidebar:hover + .main {
        margin-left: 200px;
    }

    /*Center Brand*/
    nav.sidebar.navbar.sidebar > .container .navbar-brand,
    .navbar > .container-fluid .navbar-brand {
        margin-left: 0px;
    }
    /*Center Brand*/
    nav.sidebar .navbar-brand,
    nav.sidebar .navbar-header {
        text-align: center;
        width: 100%;
        margin-left: 0px;
    }

    /*Center Icons*/
    nav.sidebar a {
        padding-right: 13px;
    }

    /*adds border top to first nav box */
    nav.sidebar .navbar-nav > li:first-child {
        border-top: 1px #e5e5e5 solid;
    }

    /*adds border to bottom nav boxes*/
    nav.sidebar .navbar-nav > li {
        border-bottom: 1px #e5e5e5 solid;
    }

    /* Colors/style dropdown box*/
    nav.sidebar .navbar-nav .open .dropdown-menu {
        position: static;
        float: none;
        width: auto;
        margin-top: 0;
        background-color: transparent;
        border: 0;
        -webkit-box-shadow: none;
        box-shadow: none;
    }

    /*allows nav box to use 100% width*/
    nav.sidebar .navbar-collapse,
    nav.sidebar .container-fluid {
        padding: 0 0px 0 0px;
    }

    /*colors dropdown box text */
    .navbar-inverse .navbar-nav .open .dropdown-menu > li > a {
        color: #777;
    }

    /*gives sidebar width/height*/
    nav.sidebar {
        width: 200px;
        height: 100%;
        margin-left: -160px;
        float: left;
        z-index: 8000;
        margin-bottom: 0px;
    }

    /*give sidebar 100% width;*/
    nav.sidebar li {
        width: 100%;
    }

    /* Move nav to full on mouse over*/
    nav.sidebar:hover {
        margin-left: 0px;
    }
    /*for hiden things when navbar hidden*/
    .forAnimate {
        opacity: 0;
    }
}

/* .....NavBar: Fully showing nav bar..... */

@media (min-width: 1330px) {
    /*Allow main to be next to Nav*/
    .main {
        width: calc(100% - 200px); /*keeps 100% minus nav size*/
        margin-left: 200px;
    }

    /*Show all nav*/
    nav.sidebar {
        margin-left: 0px;
        float: left;
    }
    /*Show hidden items on nav*/
    nav.sidebar .forAnimate {
        opacity: 1;
    }
}

nav.sidebar .navbar-nav .open .dropdown-menu > li > a:hover,
nav.sidebar .navbar-nav .open .dropdown-menu > li > a:focus {
    color: #ccc;
    background-color: transparent;
}

nav:hover .forAnimate {
    opacity: 1;
}
section {
    padding-left: 15px;
}
a {
    text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// Admin.vue?072e708c